import React, { Fragment } from 'react'

import ImageCropper from './image-cropper'
import Modal from '../modal'
import { i18n } from '../../validator'
import classnames from 'classnames'
import Configurator from '../../configurator'
import { onModalClose } from './actions/on-modal-close'
import { getResult } from './actions/on-crop'
import store from '../../admin/store'
import {
    CLEAN_IMAGE_CROPPER,
    SET_BUSY_IMAGE_CROPPER,
} from '../../admin/reducers/image-cropper'

@i18n()
export default class ImageUpload extends Configurator {

    state = {
        cropModalOpen: !!this.props.cropModalOpen,
    }

    /**
     * toggles image upload modal
     */
    toggle = () => {
        onModalClose(() => this.setState({ cropModalOpen: !this.state.cropModalOpen }))
    }


    onImageSave = () => {
        const {
            onImageSave,
            onImageUpdate,
            attribute,
        } = this.props

        store.dispatch({
            type: SET_BUSY_IMAGE_CROPPER,
            busy: true,
        })

        Promise.resolve()
            .then(() => getResult())
            .then(outputImage => onImageUpdate?.(attribute, outputImage))
            .then(() => typeof onImageSave === 'function' ? onImageSave() : {})
            .then(() => store.dispatch({
                type: CLEAN_IMAGE_CROPPER,
            }))
            .then(() => this.setState({ cropModalOpen: false }))
    }

    /**
     * renders component base
     *
     * @return {*}
     */
    render = () => {

        const {
            text,
            description,
            button,
            children,
            rounded,
            previewWidth,
            previewHeight,
            previewMaxWidth,
            defaultFile,
            defaultUserIcon,
        } = this.props

        return (
            <Fragment>
                {description &&
                    <small>{description}</small>
                }

                {button &&
                    <span onClick={this.toggle}>
                        {children}
                    </span>
                }

                {!button &&
                    <div onClick={this.toggle}>
                        <img
                            src={defaultFile || defaultUserIcon || '/images/file-upload.png'}
                            alt=""
                            className="cursor-pointer d-inline-block m-0 m-sm-2"
                            style={{
                                // backgroundSize: backgroundImage ? (defaultCrop.aspect ? 'cover' : 'contain') : 'auto',
                                maxWidth: previewMaxWidth ?? '100%',
                                borderRadius: rounded ? '50%' : 0,
                            }}
                            width={previewWidth ?? 'auto'}
                            height={previewHeight ?? 'auto'}
                        />
                    </div>
                }

                {text &&
                    <Fragment>
                        <br/>
                        <span className="cursor-pointer" onClick={this.toggle}>
                            {text}
                        </span>
                    </Fragment>
                }

                {this.renderCropModal()}
            </Fragment>
        )
    }

    /**
     * renders crop modal
     *
     * @return {*}
     */
    renderCropModal = () => {
        const { cropModalOpen } = this.state

        const {
            aspect,
            cropShape,
            modalDescription,
            defaultFile,
            defaultUserIcon,
        } = this.props

        if (!cropModalOpen) {
            return null
        }

        return (
            <Modal
                description={modalDescription}
                dialogClass={classnames({
                    'modal-lg': true,
                    'mw-100': this.isResponsive(),
                })}
                handleHideModal={this.toggle}
                content={() => (
                    <ImageCropper
                        defaultImage={defaultFile || defaultUserIcon || null}
                        onImageSave={this.onImageSave}
                        aspect={aspect}
                        cropShape={cropShape}
                    />
                )}
                closeModal={this.toggle}
                keyboard={false}
                backdrop="static"
            />
        )
    }
}
